export const useEnv = () => {
  const partnerName = process.env.REACT_APP_PARTNER_NAME;
  const displayName = process.env.REACT_APP_DISPLAY_NAME;
  const logoUrl = process.env.REACT_APP_DASHBOARD_LOGO_URL;
  const logoFormatType =
    process.env.REACT_APP_DASHBOARD_LOGO_TYPE?.toLowerCase();

  const isEastview = partnerName === "eastview";
  const isResilender = partnerName === "resilender";
  const isHandsomeHomebuyer = partnerName === "handsomeHomebuyer";
  const isResfin =
    partnerName === "resfin" ||
    partnerName === "eastview" ||
    partnerName === "lendmarq";
  const isLendmarq = partnerName === "lendmarq";
  const isDev = process.env.NODE_ENV === "development";
  // const isDev = process.env.NODE_ENV !== "production";
  return {
    partnerName,
    logoUrl,
    displayName,
    logoFormatType,
    isResilender,
    isHandsomeHomebuyer,
    isResfin,
    isLendmarq,
    isEastview,
    isDev,
  };
};
